import slugify from 'slugify';
import { getId } from './brandDiffsUtils';
const imageutils = {
    // res: {
    //   HIRES: { width: 1571, height: 2000 },
    //   LG: { width: 1024, height: 1304 },
    //   MD: { width: 768, height: 977 },
    //   SM: { width: 360, height: 458 },
    //   XS: { width: 73, height: 93 },
    //   XXS: { width: 15, height: 19 },
    // },
    transform: function (url, size, alt, quality, format) {
        if (!url) {
            return url;
        }
        if (url.indexOf('thron') > -1) {
            let name = alt ? slugify(alt, { remove: /[*+~.()'"!:@/]/g, lower: true }) : 'image';
            let fullurl = url.replace(/\/0x0\/.*/, `/${size.width}x${size.height}/${name}.jpg`);
            let params = [];
            params.push(['scalemode', 'centered']);
            params.push(['adjustcrop', 'reduce']);
            const imgQuality = quality || window.imagequality;
            if (imgQuality > 0) {
                params.push(['quality', imgQuality]);
            }
            if (window.webpsupported) {
                switch (format) {
                    case 'avif':
                        params.push(['format', 'avif']);
                        break;
                    default:
                        params.push(['format', 'WEBP']);
                        break;
                }
            }
            if (params.length > 0) {
                fullurl = fullurl + '?' + params.map((i) => i[0] + '=' + i[1]).join('&');
            }
            return fullurl;
        }
        if (url.includes('fluidconfigure')) {
            return `${url}?width=${size.width}&height=${size.height}`;
        }
        url = this.clearParams(url);
        return `${url}?sw=${size.width}` + ((size.height && `&sh=${size.height}`) || '');
    },
    hires: function (url, alt) {
        return this.transform(url, HIRES, alt);
    },
    large: function (url, alt) {
        return this.transform(url, LG, alt);
    },
    medium: function (url, alt) {
        return this.transform(url, MD, alt);
    },
    small: function (url, alt) {
        return this.transform(url, SM, alt);
    },
    extraSmall: function (url, alt) {
        return this.transform(url, XS, alt);
    },
    clearParams: function (url) {
        try {
            if (url.indexOf('?') < 0)
                return url;
            const urlObj = new URL(url);
            return urlObj.href.replace(urlObj.search, '');
        }
        catch (e) {
            window.devmode && console.log('Impossible to clearParams of', url);
        }
        return url;
    },
    srcset: function (url, maxwidth, sizes) {
        url = this.clearParams(url);
        if (!sizes) {
            sizes = Object.values(window.mqObj).map((ww) => ({
                width: ww,
            }));
        }
        if (!sizes.length)
            return '';
        if (maxwidth && sizes.some((size) => size.width > maxwidth)) {
            let indexLimit = sizes.findIndex((size) => size.width > maxwidth);
            sizes.splice(indexLimit);
            sizes.push({
                width: maxwidth,
            });
        }
        return sizes
            .map((size) => {
            return `${this.transform(url, size, '')} ${size.width}w`;
        })
            .join(',');
    },
};
export default imageutils;
// let aspectratio = 2000 / 1571; // oldimages
let aspectratio = {
    MO: 2880 / 1920,
    ST: 2880 / 2160,
};
const size = (width) => {
    return {
        width: width,
        height: Math.round(width * aspectratio[getId()]),
    };
};
export const HIRES = size(1571);
export const LG = size(1024);
export const MD = size(768);
export const SM = size(360);
export const XS = size(73);
export const XXS = size(30); // servirà per il lazyloading
